import { Component, Input } from '@angular/core';
import { GameAnswers } from '../models/game-answers.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-score-card',
  templateUrl: './score-card.component.html',
  styleUrl: './score-card.component.scss'
})
export class ScoreCardComponent {

  @Input() results!: GameAnswers;

  constructor(private modal: NgbActiveModal) { }
  
  get title(): string {
    if (this.results.points > 0) {
      return 'WINNER';
    }
    return 'Better Luck Next Time';
  }

  close() {
    this.modal.close();
  }

  dismissModal() {
    this.modal.dismiss();
  }
}
